import axios, { AxiosRequestConfig } from "axios";
import { retrieveAuthToken } from "../features/user/userActions";
import { isOfflineMode } from "./offlineMode";

export class Api {

  static get<T>(url: string, config?: AxiosRequestConfig) {
    if (isOfflineMode()) {
      return Promise.reject(
        new Error("API calls are disabled in offline mode")
      );
    }
    const authToken = retrieveAuthToken();
    return axios.get<T>(url, {
      ...config,
      headers: {
        ...config?.headers,
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : null),
      },
    });
  }
  static post<T>(url: string, data?: unknown, config?: AxiosRequestConfig) {
    if (isOfflineMode()) {
      return Promise.reject(
        new Error("API calls are disabled in offline mode")
      );
    }
    const authToken = retrieveAuthToken();
    return axios.post<T>(url, data, {
      ...config,
      headers: {
        ...config?.headers,
        ...(authToken ? { Authorization: `Bearer ${authToken}` } : null),
      },
    });
  }
}
